import { connect } from "react-redux";

import {
  selectCategories,
  selectCurrentDlsCategory
} from "~/store/selectors/dls";
import { selectIsDLSLoading } from "~/store/ducks/application/materials/isDLSMaterialsLoading";
import { selectCatsort } from "~/store/ducks/domain/config";

import DlsCategoriesList from "./DlsCategoriesList";

const mapStateToProps = state => ({
  dlsCategories: selectCategories(state),
  currentDlsCategory: selectCurrentDlsCategory(state),
  isDLSMaterialsLoading: selectIsDLSLoading(state),
  catsort: selectCatsort(state)
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(DlsCategoriesList);
